import { FiltersMap } from '../model';
import { CollectionState } from './CollectionState';
import { computed, makeObservable } from 'mobx';

export interface PaginationModeOffsetParams<
  T,
  F extends FiltersMap = FiltersMap,
> {
  collection: CollectionState<T, F>;
}

export class PaginationModeOffset<T, F extends FiltersMap = FiltersMap> {
  static readonly id = 'offset' as const;

  readonly collection: CollectionState<T, F>;
  constructor(params: PaginationModeOffsetParams<T, F>) {
    this.collection = params.collection;
    makeObservable(this, {
      fetchedLastPage: computed,
    });
  }

  get fetchedLastPage() {
    const {
      totalPages,
      result: { pages, hasNext },
    } = this.collection;
    return hasNext != null ? !hasNext : pages.length >= totalPages;
  }

  setCursor() {}

  get id() {
    return PaginationModeOffset.id;
  }
}
